import React, { useState } from "react";
import styled from "styled-components";
import Button from "./Buttons";
import { Colors } from "../ColorConstants";

const Textfield = ({
  onChange,
  placeholder,
  placeholderColor,
  variant,
  type,
  isRounded,
  size,
  endIcon,
  label,
  color,
  value,
  disabled,
  textColor,
  error,
  required,
  name,
  prefilled,
}) => {
  const [dropDownActive, setDropDownActive] = useState(false);
  const handleEdit = () => {};

  return (
    <TextFieldWrapper>
      {label ? (
        <Label color={color}>
          {label}
          {required && <Required> *</Required>}
        </Label>
      ) : null}

      <InputField
        name={name}
        value={value}
        type={type || "text"}
        placeholder={placeholder}
        variant={variant}
        isRounded={isRounded || false}
        width={size || "medium"}
        onChange={onChange}
        color={disabled ? Colors.cloudyGrey : textColor || Colors.black}
        disabled={disabled || false}
        error={error || false}
        placeholderColor={placeholderColor}
        prefilled={prefilled}
      />

      {endIcon ? (
        <EndIcon>
          <Button icon={endIcon} onClick={handleEdit} />
        </EndIcon>
      ) : null}
    </TextFieldWrapper>
  );
};

export default Textfield;

const TextFieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const MobileFieldWrapper = styled.div`
  padding: 0.5rem 0.3rem;
  background: ${(props) =>
    props.prefilled ? Colors.athensGrey : Colors.white};
  border: ${(props) =>
    props.error === true
      ? "0.0625rem solid " + Colors.white
      : props.isRounded === false
      ? "0.0625rem solid" + Colors.magnolia
      : "0.0625rem solid" + Colors.black};
  border-radius: ${(props) =>
    props.isRounded === false ? "0.25rem" : "0.5rem"};
  display: flex;
  flex-direction: row;
`;

const CodeDropDown = styled.div`
  cursor: pointer;
  flex-grow: 0.7;
  position: relative;
  justify-content: space-between;
  background-color: white;
  width: 10px;
  border-right: 1px solid #9fa2b4;
  font-family: "Poppins";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  color: #9fa2b4;
`;

const CodeDropDownSelected = styled.div`
  flex-grow: 1;
  display: flex;
  gap: 1px;
  background-color: white;
`;

const CodeDropDownList = styled.div`
  position: absolute;
  padding: 5px 5px 5px 0px;
  left: 0;
  top: 2rem;
  border-radius: 0.25rem;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
  background-color: white;
`;

const CodeDropDownListItem = styled.div`
  padding: 2px 2px;
  flex-grow: 1;
  display: flex;
  gap: 1px;
  background-color: white;
`;

const InputField = styled.input`
  padding: 0.75rem 0.5rem;
  background: ${(props) =>
    props.prefilled ? Colors.athensGrey : Colors.white};
  border: ${(props) =>
    props.error === true
      ? "0.0625rem solid " + Colors.red
      : props.isRounded === false
      ? "0.0625rem solid" + Colors.magnolia
      : "0.0625rem solid" + Colors.black};
  border-radius: ${(props) =>
    props.isRounded === false ? "0.25rem" : "0.5rem"};
  font-family: "Poppins";
  font-size: 16px;
  line-height: 0.75rem;
  color: ${Colors.secondaryBlack};
  :focus {
    outline: none;
  }
  ::placeholder {
    color: ${(props) =>
      props.placeholderColor ? props.placeholderColor : Colors.cloudyGrey};
    padding: 0.125rem;
    font-family: "Poppins";
  }
  :disabled {
    background-color: ${(props) =>
      props.prefilled ? Colors.athensGrey : Colors.white};
    color: ${(props) =>
      props.prefilled ? Colors.secondaryBlack : Colors.logan};
    cursor: no-drop;
  }
  ::-ms-reveal,
  ::-ms-clear {
    display: none;
  }
`;
const CodeImage = styled.img``;

const CodeText = styled.span`
  margin: auto;
  padding-left: 3px;
`;

const EndIcon = styled.span`
  position: absolute;
  margin-left: -2.8rem;
  margin-top: 1.25rem;
`;

const Label = styled.label`
  color: ${(props) => (props.color ? props.color : Colors.purplishGrey)};
  font-family: "Poppins";
  font-size: 16px;
  line-height: 0.75rem;
`;

const Required = styled.span`
  color: ${Colors.red};
`;

const DropButton = styled.img`
  margin: auto;
`;
